// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReminderPopup_btn_confirm__AGcKw:disabled {
  font-weight: bold !important;
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-theme-deactivated) !important;
  border: 1px solid var(--color-theme-deactivated) !important;
}

.ReminderPopup_btn_delete__HhZ4I {
  font-weight: bold !important;
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-font-black) !important;
  border: 1px solid var(--color-theme-black) !important;
}

.ReminderPopup_btn_delete__HhZ4I:disabled {
  font-weight: bold !important;
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-theme-deactivated) !important;
  border: 1px solid var(--color-theme-deactivated) !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ReminderPopup/ReminderPopup.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,gDAAgD;EAChD,2DAA2D;AAC7D;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,gDAAgD;EAChD,2DAA2D;AAC7D","sourcesContent":[".btn_confirm:disabled {\n  font-weight: bold !important;\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-theme-deactivated) !important;\n  border: 1px solid var(--color-theme-deactivated) !important;\n}\n\n.btn_delete {\n  font-weight: bold !important;\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-font-black) !important;\n  border: 1px solid var(--color-theme-black) !important;\n}\n\n.btn_delete:disabled {\n  font-weight: bold !important;\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-theme-deactivated) !important;\n  border: 1px solid var(--color-theme-deactivated) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn_confirm": `ReminderPopup_btn_confirm__AGcKw`,
	"btn_delete": `ReminderPopup_btn_delete__HhZ4I`
};
export default ___CSS_LOADER_EXPORT___;
